namespace GeniuzPOS.AdvPromo {
    export interface Adv05ItemExDtRow {
        Id?: number;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PmId?: string;
        PmGroupId?: string;
        PmType?: number;
        PluCode?: string;
        SellUnitPrice1?: number;
        SkuCode?: string;
        PluShortDesc?: string;
        ItemType?: number;
        StyleId?: string;
        StyleName?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        SupplCode?: string;
        SupplName?: string;
    }

    export namespace Adv05ItemExDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmId';
        export const localTextPrefix = 'AdvPromo.Adv05ItemExDt';
        export const lookupKey = 'AdvPromo.Adv05ItemExDt';

        export function getLookup(): Q.Lookup<Adv05ItemExDtRow> {
            return Q.getLookup<Adv05ItemExDtRow>('AdvPromo.Adv05ItemExDt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PmId = "PmId",
            PmGroupId = "PmGroupId",
            PmType = "PmType",
            PluCode = "PluCode",
            SellUnitPrice1 = "SellUnitPrice1",
            SkuCode = "SkuCode",
            PluShortDesc = "PluShortDesc",
            ItemType = "ItemType",
            StyleId = "StyleId",
            StyleName = "StyleName",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            SupplCode = "SupplCode",
            SupplName = "SupplName"
        }
    }
}
